module.exports = __webpack_public_path__ + "img/image2.0dfefc78.jpg";